export default __webpack_public_path__ + "static/media/cleaning-gif.11de4ec5.gif";